import { publicTripPath } from '@lib/publicLinks'

/**
 * Route pattern for the public Shared trip page, composed from the canonical
 * public-link builder so the router path and copied share links can never
 * drift. The `:tripCode` param name must match the `useParams` key in
 * `PublicTripOverviewPage` — the route test pins the pair together. (Lives in
 * its own module so the page file only exports a component — react-refresh.)
 */
export const PUBLIC_TRIP_OVERVIEW_PATH = publicTripPath(':tripCode')
